import React from 'react';
import {
  AreaChart,
  Area,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

// Custom Tooltip for Scans
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;

  return (
    <div className="bg-gray-900/95 backdrop-blur-sm px-2 py-1 rounded shadow-xl border border-cyan-500/30 text-xs">
      <p className="text-gray-400">{label}</p>
      <p className="font-medium text-cyan-400">{payload[0]?.value} scans</p>
    </div>
  );
};

const ScansMiniChart = ({ data }) => {
  // Default mock data for 7 days
  const defaultData = [
    { date: '24', scans: 5 },
    { date: '25', scans: 8 },
    { date: '26', scans: 6 },
    { date: '27', scans: 10 },
    { date: '28', scans: 7 },
    { date: '29', scans: 9 },
    { date: '30', scans: 7 },
  ];

  const chartData = data || defaultData;

  return (
    <div className="w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={chartData}
          margin={{ top: 2, right: 2, bottom: 2, left: 2 }}
        >
          <defs>
            <linearGradient id="scanGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#06B6D4" stopOpacity={0.6} />
              <stop offset="50%" stopColor="#0891B2" stopOpacity={0.3} />
              <stop offset="100%" stopColor="#164E63" stopOpacity={0.1} />
            </linearGradient>
          </defs>

          <Area
            type="monotone"
            dataKey="scans"
            stroke="#06B6D4"
            strokeWidth={1.5}
            fill="url(#scanGradient)"
            dot={false}
            activeDot={{
              r: 3,
              fill: '#06B6D4',
              stroke: '#000',
              strokeWidth: 1,
            }}
            animationDuration={600}
          />

          <Tooltip
            content={<CustomTooltip />}
            cursor={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ScansMiniChart;
